module.exports = __webpack_public_path__ + "img/comm.6eee9037.jpg";